import React, { useEffect, useState } from 'react'
import { Link } from "gatsby-plugin-intl";
import { getLinkPrefix } from '../../utils/getLinkPrefix';

export const RecentlyViewMenu = ({ langKey, country_code }) => {
  const [menuItems, setMenuItems] = useState([]);

  const loadMenuItems = () => {
    const rv_items = localStorage.getItem('rv_items') ? JSON.parse(localStorage.getItem('rv_items')) : [];
    setMenuItems(rv_items);
  }

  useEffect(() => {
    if (typeof localStorage !== 'undefined') {
      loadMenuItems();
    }
  }, []);

  return (
    <div className="recently-view-menu margin-bottom">
      {
        (menuItems && menuItems?.length > 0) ?
          <div>
            <strong>Recently viewed articles</strong>
            <ul className="left-side-menu">
              {
                menuItems?.map(menuItem => (
                  <li key={menuItem.id}>
                    <Link to={getLinkPrefix('articles', `${menuItem.slug}`)} language={langKey}>{menuItem.title}</Link>
                  </li>
                ))
              }
            </ul>
          </div>
          : null
      }
    </div>
  )
}
